import { Layout } from 'antd';
import NavBar from "../../components/NavBar";
import BranchDetail from "../../components/branch/BranchDetail";

const { Content } = Layout;

function BranchMag({ match }) {
   return (
      <Layout className="container main-layout">
         <NavBar />
         <Layout className="bg-gray">
            <Content className="layout-content">
               <BranchDetail/>
            </Content>
         </Layout>
      </Layout>
   );
}

export default BranchMag;
